import * as commonActions from './common'
import * as editPatientActions from './editPatient'
import * as createPatientActions from './createPatient'

export default {
    ...commonActions,
    ...editPatientActions,
    ...createPatientActions
}

